var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',{staticClass:"titulo"},[_vm._v(" Essa trilha passa pelos parques: ")]),_vm._l((_vm.parquesOnTrilhas),function(i,index){return _c('div',{key:index,staticClass:"parques-trilhas"},[_vm._v(" "+_vm._s(i.nome)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }